import React from 'react';
import Icon from '../AppIcon';

const Checkbox = ({ checked, onChange, disabled = false, className = '', indeterminate = false }) => {
  return (
    <label className={`relative inline-flex items-center cursor-pointer ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}>
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        className="sr-only peer"
      />
      <div className={`
        w-5 h-5 rounded-md border-2 flex items-center justify-center
        transition-all duration-200 ease-in-out
        ${checked || indeterminate
          ? 'bg-gradient-to-br from-blue-500 to-blue-600 border-blue-600 shadow-sm shadow-blue-500/30' 
          : 'bg-white dark:bg-gray-800 border-gray-300 dark:border-gray-600 hover:border-blue-400 dark:hover:border-blue-500'
        }
        ${disabled ? '' : 'peer-focus:ring-2 peer-focus:ring-blue-500/20'}
        ${className}
      `}>
        {checked && (
          <Icon 
            name="Check" 
            size={14} 
            className="text-white transform transition-transform duration-150 scale-100"
          />
        )}
        {indeterminate && !checked && (
          <div className="w-2.5 h-0.5 bg-white rounded-full"></div>
        )}
      </div>
    </label>
  );
};

// Support both default and named exports for compatibility
export { Checkbox };
export default Checkbox;
